import { tokenFingerprint } from './operandiCaptureQueue';
import { operandiRetryRevision } from './operandiRetrySession';

async function key(scope) {
  const fingerprint = await tokenFingerprint(scope?.token);
  if (!fingerprint || !scope?.orgId || !scope?.locationId) throw new Error('Secure grant retry storage unavailable');
  return `operandi-grant-pending-v1:${JSON.stringify([scope.orgId,scope.locationId,fingerprint])}`;
}
export async function persistGrantRetry(scope, request, config) {
  const revision = operandiRetryRevision();
  const name = await key(scope);
  if (revision !== operandiRetryRevision()) throw new Error('Operandi retry session ended');
  window.sessionStorage.setItem(name,JSON.stringify({request,config}));
  return name;
}
export async function loadGrantRetry(scope) {
  const revision = operandiRetryRevision();
  const name = await key(scope), raw = window.sessionStorage.getItem(name);
  if (revision !== operandiRetryRevision()) return null;
  if (!raw) return null;
  const saved = JSON.parse(raw);
  const body = saved?.request, config = saved?.config;
  if (!body || !config || !/^[a-f0-9]{8}(-[a-f0-9]{4}){3}-[a-f0-9]{12}$/.test(body.command_id) ||
      body.binding_id !== config.binding_id || body.binding_version !== config.binding_version ||
      body.expected_grants_version !== config.grants_version || typeof body.enabled !== 'boolean' ||
      typeof body.user_id !== 'string' || !body.user_id || typeof body.reason !== 'string' || !body.reason.trim() ||
      JSON.stringify(body.expected_site_ids) !== JSON.stringify(config.site_ids) ||
      JSON.stringify(body.expected_entity_ids) !== JSON.stringify(config.entity_ids) ||
      !Array.isArray(config.user_ids) || !Array.isArray(config.eligible_user_ids) ||
      config.authority !== 'ADVISORY_ONLY' || config.no_action_authority !== true)
    throw new Error('Pending grant retry is unreadable; review the recorded grant before changing it');
  return {...saved,key:name};
}
export function clearGrantRetry(name) {
  window.sessionStorage.removeItem(name);
}
